export const salesChannels = 
{
    Zabka: 50002,
    B2B: 50003,
}